import { HelpCircle } from "lucide-react";

import { ResponsiveTooltip } from "@krea/shared/design-system/ResponsiveTooltip";

// Rendered next to the input rather than inside the field's <label> —
// ControlledWrapper passes its `label` prop through FieldLabel, which is a
// native <label>, and <button> is not a valid descendant of one.
export const TotalCostTooltip = () => {
  return (
    <ResponsiveTooltip
      trigger={
        <button
          type="button"
          aria-label="About the total cost"
          className="inline-flex cursor-help items-center justify-center rounded-full text-gray-600 hover:text-gray-500 focus:outline-hidden focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2"
        >
          <HelpCircle className="size-4" />
        </button>
      }
    >
      Everything the customer pays: the approved amount plus all interest, the
      setup fee, monthly administration fees and any other fees you charge.
    </ResponsiveTooltip>
  );
};
